// Shared cache window used by Redux slices that debounce refetches.
export const CACHE_DURATION = 30_000;

// Returns true when a slice was fetched recently enough to skip a refetch.
export const isCacheFresh = (lastFetched: number | null | undefined): boolean =>
  typeof lastFetched === 'number' && Date.now() - lastFetched < CACHE_DURATION;
